// extracted by mini-css-extract-plugin
export default {"active":"Pagination_active__eU5YB","pagination":"Pagination_pagination__GQCCK","btnIcon":"Pagination_btnIcon__N2jxK"};